const PHRASES = ["Taste the Palace", "Royal Catering", "Authentic Spices", "Tandoor Fired", "Made with Heart"];

export default function Marquee() {
  const row = [...PHRASES, ...PHRASES];
  return (
    <section data-testid="marquee" className="relative py-8 md:py-10 border-y border-[#D4AF37]/20 bg-[#140A0D] overflow-hidden">
      <div className="marquee-track">
        {row.map((p, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="font-display italic text-3xl md:text-5xl text-[#FDFBF7]/90">{p}</span>
            <span className="text-[#D4AF37] text-2xl md:text-3xl">◆</span>
          </span>
        ))}
      </div>
    </section>
  );
}
